import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem3,
    GridItem3xs10,
    GridItem3xs10NotIsXsDownScreen,
    GridItem5,
    GridItem4xs10,
    GridItem4xs10NotIsXsDownScreen,
    GridItem6,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import familiaresList from '../../../business-rules/List/familiaresList'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoEducacao,
    rowPertentePageEducacao,
    setPageInclusaoEducacao,
    Familiar,
    IconButtonClearEntradaDadosEducacao,
    TipoEducacao,
    TipoPeriodicidadePagto,
    Valor,
    ValorAcumulado,
    IdadeInicial,
    IdadeFinal,
} from '../despesas-form/DespesasCompEducacao'

import {
    incrementaContEducacao,
    processaRegistrosDefaultIniciaisEducacao,
    calculaEducacaoFilhaoEnteadaoBaseOutraosFilhaosEnteadaos,
    processaValoresDefaultIniciaisEducacao,
    calculaTotaisEducacao,
} from '../despesas-form/DespesasServiceEducacao'

import {
    processaFormSortAscFamiliar
} from './FormService'

import DespesasFormEducacaoItem from '../despesas-form/DespesasFormEducacaoItem'



const FormFormEducacao = ({ values, handleChange, setFieldValue, jsonConfiguracao, title }) => {

    const [expandiu, setExpandiu] = useState(false)
    
    processaRegistrosDefaultIniciaisEducacao(values, jsonConfiguracao)

    calculaTotaisEducacao(values)

    useSingleton(async () => {

        calculaEducacaoFilhaoEnteadaoBaseOutraosFilhaosEnteadaos(values)

        processaFormSortAscFamiliar(values.educacao)

        values.pageEducacao = obtemPage(values.pageEducacaoList, HARDCODE.idFamiliarPage)
    })

    salvaPage(values.pageEducacao, values.pageEducacaoList, HARDCODE.idFamiliarPage)

    values.educacaoPagination = values.educacao

    const isXsDownScreen = IsXsDownScreen()


    
    return (
        <FieldArray name="educacao">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.educacao?.map((item, ind) => {

                            if (rowPertentePageEducacao(values, ind)) {

                                processaValoresDefaultIniciaisEducacao(item)

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem4xs10>
                                                <GridContainer>
                                                    <GridItem5>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem5>
                                                    
                                                    <GridItem7>
                                                        <TipoEducacao
                                                            TextFieldNumberSelectTipoEducacao={
                                                                TextFieldNumberSelect
                                                            }
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem7>
                                                </GridContainer>
                                            </GridItem4xs10>

                                            {item.tipoEducacao
                                                ?
                                                    <GridItem3xs10>
                                                        <GridContainer>
                                                            <GridItem6>
                                                                <TipoPeriodicidadePagto
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem6>
                                                            <GridItem6>
                                                                <Valor
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem6>
                                                        </GridContainer>
                                                    </GridItem3xs10>
                                                :
                                                    <GridItem3xs10NotIsXsDownScreen />
                                            }

                                            {item.tipoEducacao
                                                ?
                                                    <GridItem4xs10>
                                                        <GridContainer>
                                                            <GridItem3>
                                                                <IdadeInicial
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem3>
                                                            <GridItem3>
                                                                <IdadeFinal
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem3>
                                                            {item.valorAcumulado !== 0  && (
                                                                <GridItem6>
                                                                    <ValorAcumulado
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange} 
                                                                    />
                                                                </GridItem6>
                                                            )}
                                                        </GridContainer>
                                                    </GridItem4xs10>
                                                :
                                                    <GridItem4xs10NotIsXsDownScreen />
                                            }

                                            <GridItem1xs2>
                                                <GridContainer>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <CustomizedDialogsPopup
                                                            maxWidth="sm"
                                                            popupTitle={title}
                                                            tooltipTitle={LABEL.expandir}
                                                            PopupButton={IconButtonMaisInformacoes}
                                                            popupButtonDestaque={false}
                                                            DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                                                            popupComponent={
                                                                <DespesasFormEducacaoItem
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={arrayHelpers}
                                                                    item={item}
                                                                    ind={ind}
                                                                    simplificado={true}
                                                                />
                                                            }
                                                            open={setExpandiu}
                                                            afterClose={setExpandiu}
                                                        />
                                                    </GridItem6>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <IconButtonClearEntradaDadosEducacao
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            ind={ind}
                                                            arrayHelpers={arrayHelpers}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem1xs2>
                                        </GridContainer>
                                        
                                        {isXsDownScreen && values.educacaoPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoEducacao
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    <GridContainerGridItemButtonIncluirLinha>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirEducacao} 
                            align='right'
                            disabled={familiaresList(values).length === 0 ? true : false}
                            onClick={() => 
                                {
                                    incrementaContEducacao(values)
                                    arrayHelpers.push({
                                        id: values.contEducacao,
                                        familiar: HARDCODE.idFamiliarCliente,
                                    })
                                    setPageInclusaoEducacao(values, setFieldValue)
                                }
                            }
                        />
                    </GridContainerGridItemButtonIncluirLinha>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormEducacao